import { useEffect, useRef } from 'react';
import { TrackingService } from '@/service/tracking/trackingService';
import { usePathname } from 'next/navigation';

type Config = {
  percentageValues: number[];
  eventCb: (percentage: number) => void;
};

export const useScrollPercentageTracking = (config: Config) => {
  const trackedPercentage = useRef<number[]>([]);
  const pathname = usePathname();

  useEffect(() => {
    trackedPercentage.current = [];

    const markers = config.percentageValues.map((percentage) => {
      const marker = TrackingService.createTrackingMarker(`${percentage}%`);
      return { percentage, marker };
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const percentage = markers.find((m) => m.marker === entry.target)?.percentage;
            if (percentage !== undefined && !trackedPercentage.current?.includes(percentage)) {
              trackedPercentage.current?.push(percentage);
              config.eventCb(percentage);
            }
          }
        });
      },
      { threshold: 0 },
    );

    markers.forEach(({ marker }) => observer.observe(marker));

    return () => {
      markers.forEach(({ marker }) => {
        observer.unobserve(marker);
        document.body.removeChild(marker);
      });
    };
  }, [pathname]);
};
